import React, { Suspense } from 'react';
import { FirebaseAppProvider, SuspenseWithPerf } from 'reactfire';
import { ThemeProvider } from '../components/helpers/ThemeContext';
import { fireConfig } from './fireConfig';

export const wrapRootElement = ({ element }) => {
  if (typeof window !== "undefined") {
    if (typeof window === "undefined") return <p>Loading...</p>
    return (
      // <FirebaseAppProvider firebaseConfig={fireConfig}>
        <Suspense fallback={"Loading"}>
          <ThemeProvider>
            {element}
          </ThemeProvider>
        </Suspense>
      // </FirebaseAppProvider>
    )
  }
}